import './home.css'
import React, { Component } from "react"
import { connect } from 'react-redux'
import axios from 'axios';
import Menu from './components/menu'
import Header from './components/header'
import Icons from './components/icons'
import Usp from './components/usp'
import Information from './components/information'
import Pressrelease from './components/pressrelease'
import Footer from './components/footer'
import { pathOr } from 'ramda';
import {fbFunctionsURL} from "../../firebase";

export class Home extends Component {
  constructor(props){
    super(props);
    this.state = {
      active: 0
    }
    this.handleScroll = this.handleScroll.bind(this)
  }

    componentDidMount = () => {
      const { company_id} = this.props
      if ( company_id) {
        axios.post(`${fbFunctionsURL}/subscriptions/checkSubscription`, { company_id})
      }
      window.addEventListener("scroll", this.handleScroll, true);
    }

    componentDidUpdate = (prevProps) => {
      const { company_id, authenticated, history, current_user  } = this.props
      if(pathOr(false, ['uid'], authenticated)){
        if(pathOr(false, ['company_id'], current_user)){
          history.push(`/companyprofile/${current_user.company_id}`)
        }else{
          history.push(`/dashboard`)
        }
      }
      if ( company_id && prevProps. company_id !==  company_id) {
        axios.post(`${fbFunctionsURL}/subscriptions/checkSubscription`, { company_id})
      }
    }

    componentWillUnmount() {
      window.removeEventListener("scroll", this.handleScroll, true);
    }

    handleScroll = event => {
      const { pageYOffset } = window;
      const { active } = this.state;

      if (pageYOffset > 80 && active === 0) {
        this.setState({ active: 1 });
      } else if (pageYOffset < 80 && active === 1) {
        this.setState({ active: 0 });
      }
    };

    render() {
      const {authenticated, firebase, history, current_user, t} = this.props

        return (
            <div className="home" id="main-home">
              <Menu t={t} current_user={current_user} history={history} firebase={firebase} authenticated={authenticated} active={this.state.active}/>
              <Header t={t} current_user={current_user} history={history} firebase={firebase} authenticated={authenticated} />
              <div className="home-item">
                <Information />
                {/* <Icons /> */}
                <Usp />

              </div>
              <Pressrelease t={t} />
              <div className="home-item">
                <Footer t={t} />
              </div>

            </div>
        )
    }
}

export default connect(null, null)(Home)
